export default "__VITE_ASSET__FMUH0cxm__"